import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
      <p className="footer-p">
        Code, design and copy by: &nbsp;
        <span className="who">who do you think?</span>
        &nbsp; © 2021 Erfan Hanif.
      </p>
    </footer>
  );
};

export default Footer;
